// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
  SLIDER: '[data-is="SimpleSlider"]',
};

class SimpleSlider extends WebComponent {
  constructor(props) {
    super(props);
    this.currentIndex = 0;
    this.slideInterval = 5000; // Délka zobrazení jednoho slidu v milisekundách
    this.handleNext = this.handleNext.bind(this);
    this.handlePrev = this.handlePrev.bind(this);
    this.startAutoPlay = this.startAutoPlay.bind(this);
    this.stopAutoPlay = this.stopAutoPlay.bind(this);
    this.updateHeight = this.updateHeight.bind(this);

    this.sliderContainer = document.querySelector(fragments.SLIDER);
    this.slides = Array.from(this.sliderContainer.getElementsByClassName('slide')).map((slide) => slide);
  }

  didMount() {
    const nextButton = this.sliderContainer.querySelector('.next');
    const prevButton = this.sliderContainer.querySelector('.prev');

    if (nextButton) {
      nextButton.addEventListener('click', this.handleNext);
    }
    if (prevButton) {
      prevButton.addEventListener('click', this.handlePrev);
    }

    window.addEventListener('resize', this.updateHeight);

    this.showSlide(this.currentIndex);

    // Spustíme automatické přehrávání pouze pokud je více než jeden slide
    if (this.slides.length > 1) {
      this.startAutoPlay();
    }
  }

  willUnMount() {
    const nextButton = this.sliderContainer.querySelector('.next');
    const prevButton = this.sliderContainer.querySelector('.prev');

    if (nextButton) {
      nextButton.removeEventListener('click', this.handleNext);
    }
    if (prevButton) {
      prevButton.removeEventListener('click', this.handlePrev);
    }

    window.removeEventListener('resize', this.updateHeight);

    this.stopAutoPlay();
  }

  handleNext() {
    this.showSlide(this.currentIndex + 1);
  }

  handlePrev() {
    this.showSlide(this.currentIndex - 1);
  }

  showSlide(index) {
    const totalSlides = this.slides.length;

    if (index >= totalSlides) {
      this.currentIndex = 0;
    } else if (index < 0) {
      this.currentIndex = totalSlides - 1;
    } else {
      this.currentIndex = index;
    }

    this.slides.forEach((slide, i) => {
      slide.classList.toggle('active', i === this.currentIndex);
    });

    // Nastavíme výšku kontejneru slideru podle aktuálního slidu
    this.updateHeight();
  }

  updateHeight() {
    const activeSlide = this.slides[this.currentIndex];
    this.sliderContainer.style.height = `${activeSlide.offsetHeight}px`;
  }

  startAutoPlay() {
    this.autoPlayInterval = setInterval(() => {
      this.handleNext();
    }, this.slideInterval);
  }

  stopAutoPlay() {
    clearInterval(this.autoPlayInterval);
  }
}

export default SimpleSlider;


// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/SimpleSlider.js